const Rule = (ruleName, validatorMethod, errorMsg) => {
  if (typeof validatorMethod !== 'function') {
    throw new Error('Validator method must be a function')
  }
  if (typeof errorMsg !== 'string') {
    throw new Error('Message must be a string')
  }
  return {
    name: ruleName,
    rule: validatorMethod,
    message: errorMsg
  }
}
export default Rule
